export class CallTagConstants {
   public static readonly CATEGORY_TAG = 'SAMWIN.CATEGORY';
}
